import { ItemListElements } from 'next-seo/lib/types'

import SeoContainer, { SeoContainerProps } from 'components/util/containers/SeoContainer'
import Strings from 'project/localisation'
import useWindowSize from 'components/util/useWindowSize'
import { NextPageWithLayout } from '../types/nextPageWithLayout'
import { homeBreadcrumb } from 'components/util/containers/Breadcrumbs'
import { companyFormationStrings } from 'common/strings/company-formation-strings'
import HeroBanner from 'components/hero/HeroBanner'
import Newsletter from 'components/accountancy-landing-pages/Newsletter'


const CompanyFormationPage: NextPageWithLayout<{}> = ({}) => {
  const size = useWindowSize()

  const seoProps: SeoContainerProps['seoProps'] = {
    description: companyFormationStrings.seoCompanyFormationDescription,
    openGraph: {
      url: 'https://www.hoxtonmix.com/company-information/',
    },
    title: companyFormationStrings.seoCompanyFormationTitle,
  }

  const companyFormationBreadcrumb: ItemListElements[] = [
    homeBreadcrumb()[0],
    {
      item: 'https://www.hoxtonmix.com/company-formation/',
      name: `${Strings.companyFormation}`,
      position: 2,
    },
  ]


  return (
    <SeoContainer breadcrumb={companyFormationBreadcrumb} seoProps={seoProps}>
      <main className={'overflow-x-hidden new-design d-flex flex-column'}>
        <HeroBanner
          hideFooter
          hideDownloadButtons
          robotImage={{
            alt: 'HaiRo™ robot mascot holding tie',
            dimensions: {
              height: 1058,
              width: 777,
            },
            src: '/images/new/robot-enterprise.png',
          }}
          title={
            <h1>
              UK{" "}
              <span className='color-pink2'>Company Formation</span>
            </h1>
          }
          subtitleContainerClassName='my-5'
          subtitle={
              <Newsletter>
                <div className='fs-fluid-24-32 fw-semibold lh-114 mb-4'>
                  Company formation is coming to Hoxton Mix soon.
                  <div className='d-flex mt-4 align-items-center gap-2 mb-2'>
                    <svg
                      width='26'
                      height='26'
                      viewBox='0 0 26 26'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M18.2 23.4V2.6H2.6V22.1C2.6 22.4448 2.73696 22.7754 2.98076 23.0192C3.22456 23.263 3.55522 23.4 3.9 23.4H18.2ZM22.1 26H3.9C2.86566 26 1.87368 25.5891 1.14228 24.8577C0.410892 24.1263 0 23.1343 0 22.1V1.3C0 0.955218 0.136964 0.624558 0.380761 0.380761C0.624558 0.136964 0.955218 0 1.3 0H19.5C19.8448 0 20.1754 0.136964 20.4192 0.380761C20.663 0.624558 20.8 0.955218 20.8 1.3V10.4H26V22.1C26 23.1343 25.5891 24.1263 24.8577 24.8577C24.1263 25.5891 23.1343 26 22.1 26ZM20.8 13V22.1C20.8 22.4448 20.937 22.7754 21.1808 23.0192C21.4246 23.263 21.7552 23.4 22.1 23.4C22.4448 23.4 22.7754 23.263 23.0192 23.0192C23.263 22.7754 23.4 22.4448 23.4 22.1V13H20.8ZM5.2 5.2H13V13H5.2V5.2ZM7.8 7.8V10.4H10.4V7.8H7.8ZM5.2 14.3H15.6V16.9H5.2V14.3ZM5.2 18.2H15.6V20.8H5.2V18.2Z'
                        fill='#1D1D1F'
                      />
                    </svg>
                    <h2 className='fs-fluid-20-34 text-gradient-purple mb-0'>
                      Sign up for updates
                    </h2>
                  </div>
                </div>
              </Newsletter>
          }
        />


      </main>
    </SeoContainer>
  )
}

export default CompanyFormationPage
